import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID_PROPERTY_FINDER;
const HOTJAR_SV = process.env.REACT_APP_HOTJAR_SV;

export function usePropertyFinderHotjar() {
  const location = useLocation();

  useEffect(() => {
    // Only load on property-finder routes
    if (!location.pathname.includes('/property-finder')) {
      return;
    }

    if (!window.hj) {
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_SV };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }

    if (window.hj) {
      window.hj('stateChange', location.pathname);
    }
  }, [location.pathname]);
}
